import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { MonthYearPicker } from "../components/Filters";
import { MONTHS } from "../lib/format";
import { Card } from "../components/ui/card";
import { Loader2 } from "lucide-react";

export default function Recap() {
  const [year, setYear] = useState(2026);
  const [month, setMonth] = useState(8);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/recap?year=${year}&month=${month}`).then((r) => setData(r.data)).catch(() => {});
  }, [year, month]);

  return (
    <div className="space-y-6" data-testid="recap-page">
      <div className="flex flex-col sm:flex-row justify-between gap-3">
        <div>
          <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Rekap Jumlah Sesi</h2>
          <p className="text-sm text-muted-foreground">{MONTHS[month - 1]} {year}</p>
        </div>
        <MonthYearPicker year={year} month={month} setYear={setYear} setMonth={setMonth} />
      </div>

      {!data ? (
        <div className="p-16 flex justify-center"><Loader2 className="w-7 h-7 text-gtsorange animate-spin" /></div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {data.per_school.map((s) => (
              <Card key={s.school_id} className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] p-5 bg-white" data-testid={`recap-school-${s.school_id}`}>
                <p className="text-xs text-muted-foreground">{s.school_name}</p>
                <p className="font-nunito font-extrabold text-3xl text-gtsnavy mt-1">{s.total}</p>
                <p className="text-xs text-gtsorange">total sesi</p>
              </Card>
            ))}
          </div>

          <Card className="rounded-2xl border-none shadow-[0_8px_30px_rgb(16,42,86,0.06)] bg-white overflow-hidden">
            <div className="overflow-x-auto gts-scroll">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gtsnavy text-white">
                    <th className="text-left px-4 py-3">Nama Guru</th>
                    {data.per_school.map((s) => (
                      <th key={s.school_id} className="px-4 py-3 text-center">{s.school_name}</th>
                    ))}
                    <th className="px-4 py-3 text-center bg-gtsorange">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {data.per_teacher.length === 0 && (
                    <tr><td colSpan={data.per_school.length + 2} className="text-center py-10 text-muted-foreground">Belum ada data.</td></tr>
                  )}
                  {data.per_teacher.map((t, i) => (
                    <tr key={t.teacher_id} className={i % 2 ? "bg-orange-50/30" : ""}>
                      <td className="px-4 py-2.5 font-medium text-gtsnavy">{t.teacher_name}</td>
                      {data.per_school.map((s) => (
                        <td key={s.school_id} className="px-4 py-2.5 text-center">{t.by_school[s.school_name] || 0}</td>
                      ))}
                      <td className="px-4 py-2.5 text-center font-extrabold text-gtsorange">{t.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </>
      )}
    </div>
  );
}
